import React from "react";

import CollapseComponent from "../CommonComponents/CollapseComponent";
import TransferTree from "./TransferTree";
import config from "../../../utils/config";

const SelectorDMA = ({ featureNumber, incomeValue }) => {
  const { dma } = config;

  return (
    <CollapseComponent key="DMA base" groupTitle="Open DMA selector">
      <TransferTree featureNumber={featureNumber} data={dma} />
    </CollapseComponent>
  );
};

export default SelectorDMA;
